module.exports = __webpack_public_path__ + "media/categories/2026-8d847bb6.svg";